import React, { useEffect } from 'react';
import {Box, Flex, Text} from "@chakra-ui/layout";
import {Grid, Heading} from "@chakra-ui/react";
import { StateType, useStudentAuthDispatch } from '../../../store/store';
import { useSelector } from 'react-redux';
import { getStudentLessons } from '../../../action/studentAction';

function Lessons() {
  const dispatch = useStudentAuthDispatch();
  const {data: {token}, lessons: {lessons}} = useSelector((state: StateType) => state.rootReducer.studentReducer);
  const studentToken = token.includes("Bearer") ? token.slice(17, (token.length - 2)) : token.slice(10, (token.length - 2));

  useEffect(() => {
    dispatch(getStudentLessons(studentToken));
  }, [])

  return (
    <Flex flexDirection={"column"} boxShadow="2xl" m={7} p={5} borderRadius={"20px"}>
      <Text textTransform={"capitalize"} fontWeight={"extrabold"} fontSize={"2xl"}>Lessons</Text>
      <Grid gridTemplateColumns={"repeat(auto-fit, minmax(200px, 250px))"} justifyContent={"center"} m={3}>
        {lessons.length < 1 ? (
          <Text textTransform={"capitalize"} textAlign={"center"}>No Uploaded Lessons</Text>
        ) :  lessons.map((lesson, index) => (
          <Grid key="index" gridTemplateRows={"repeat(auto-fit, minmax(250px, 1fr))"} justifyContent={"center"} m={3}>
          <Box borderRadius={2.5}>
            <video
              poster={"https://upload.wikimedia.org/wikipedia/commons/e/e8/Elephants_Dream_s5_both.jpg"}
              src={lesson.video_link}
              controls>
              Your browser does not support the video tag.
            </video>
            <Heading fontSize={"xl"} fontWeight={"bold"} textTransform={"capitalize"}
                     mt={3}>{lesson.course_name}</Heading>
            <Text lineHeight={5} noOfLines={4} fontSize={"sm"} fontWeight={"normal"} color={"brand.gray"}
                  textTransform={"capitalize"} mt={2}>
              {lesson.video_description}
            </Text>
            <Text fontSize={"md"} fontWeight={"semibold"} color={"brand.grey"} textTransform={"capitalize"}
                  mt={2.5}>{lesson.teacher_username}</Text>
          </Box>
        </Grid>
        ))}
      </Grid>
    </Flex>
  );
}

export default Lessons;